<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-end">
        <b-button variant="primary" size="lg" @click="createTemplate">
          {{ 'save' | i18n }}
        </b-button>
      </div>
      <div class="poppins">
        <div class="height100" v-if="loaded">
          <div class="inputs-block">
            <BlockHeader name="Details" />
            <div class="row">
              <div class=" col-lg-6 col-sm-12 col-xs-12">
                <Select
                  v-model="operationalArea"
                  :options="operationalAreas"
                  form-group-id="type"
                  customID="Type"
                  placeholder="Type"
                  :required="true"
                />
              </div>
              <div class=" col-lg-6 col-sm-12 col-xs-12">
                <Input
                  v-model="duration"
                  form-group-id="duration"
                  placeholder="Duration"
                  customID="Duration"
                  type="number"
                  :required="true"
                  :error="duration > MAX"
                  :errorMessage="`Max value : ${MAX}`"
                />
              </div>
              <div class=" col-lg-6 col-sm-12 col-xs-12">
                <Multiselect
                  :options="teamsList"
                  form-group-id="Teams"
                  placeholder="Teams"
                  placeholder-input="Select team"
                  :on-change="v => (teams = v)"
                  :required="true"
                  :initValues="teams"
                  customID="Teams"
                  :selected-name="{ single: 'team', plural: 'teams' }"
                />
              </div>
            </div>
          </div>
          <div class="inputs-block template">
            <BlockHeader name="Working Hours" />
            <div>
              <div class="row">
                <div class=" col-lg-3 col-sm-12 col-xs-12" v-for="day in days" :key="day">
                  <Input v-model="workingHours[day]" :placeholder="day" :customID="`Day-${day}`" />
                </div>
              </div>
            </div>
          </div>
          <div class="inputs-block template">
            <BlockHeader name="Template" />
            <div v-if="teams && teams.length">
              <div class="row">
                <div
                  class=" col-lg-6 col-sm-12 col-xs-12"
                  v-for="day in Array.from({ length: Number(duration) > MAX ? MAX : Number(duration) }, (_, i) => i + 1)"
                  :key="day"
                >
                  <div class="day">{{ 'Day' | i18n }}: {{ day }}</div>
                  <div>
                    <div v-for="(team, index) in teams" :key="team.value">
                      <Select
                        v-model="shiftTemplate[day][team.value]"
                        :options="shiftOption"
                        :customID="`select-${index}-${day}`"
                        form-group-id="TeamName"
                        :placeholder="team.text"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loader v-else />
      </div>
    </div>
  </div>
</template>

<script>
import { DeleteRowMixin, NotificationMixin } from '../../../../mixins';
import api from '../../../api';
import Notification from '../../common/notification';

import Input from '../../common/input';
import Select from '../../common/select';
import Multiselect from '../../common/multiselect';
import Loader from '../../common/loader';
import BlockHeader from '../../common/block-header';

import { SHIFTS } from '../../../../../../../constants';

export default {
  title: 'Team Details',
  components: { Input, Multiselect, Loader, BlockHeader, Select },
  mixins: [DeleteRowMixin, NotificationMixin],
  data() {
    return {
      operationalArea: '',
      teams: [],
      duration: 1,
      shiftTemplate: {},
      operationalAreas: [],
      shiftOption: Object.values(SHIFTS).map(i => ({ value: i, text: this.$translate(i) })),
      teamsList: [],
      loaded: false,
      MAX: 31,
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      workingHours: {}
    };
  },
  methods: {
    async createTemplate() {
      try {
        const payload = {
          operationalArea: this.operationalArea,
          duration: this.duration,
          workingHours: this.workingHours,
          teams: this.teams.map(t => t.value)
        };
        const template = {};
        Array.from({ length: this.duration }, (_, i) => i + 1).forEach(i => {
          template[i] = {};
          this.shiftTemplate[i];
          payload.teams.forEach(t => (template[i][t] = this.shiftTemplate[i][t]));
        });
        payload.template = template;
        const id = this.$route.params.id;
        if (id) {
          payload.id = id;
          await api.shiftTemplate.update(payload);
        } else {
          await api.shiftTemplate.create(payload);
        }
        this.$root.$emit('bv::hide::modal', 'add-team');
        Notification({ type: 'success', message: this.$translate('success') });
        this.$router.push({ name: 'shift-template' });
      } catch (err) {
        Notification({ type: 'error', message: this.$translate(err.message) });
        this.preventCloseLocal = true;
      }
    }
  },
  watch: {},
  async created() {
    this.loaded = false;
    this.operationalAreas = await api.operationalArea.get();
    this.operationalAreas = this.operationalAreas.map(v => ({
      value: v.id,
      text: this.$translate(v.name)
    }));

    const id = this.$route.params.id;
    if (id) {
      const template = await api.shiftTemplate.getByID(id);
      this.duration = Number(template.duration);
      this.operationalArea = template.operationalArea.id;
      this.workingHours = template.workingHours || {};
      this.shiftTemplate = template.template || {};
      this.teams = template.teams.map(item => ({ value: item.id, text: item.name }));
    }
    Array.from({ length: this.MAX }, (_, i) => i + 1).forEach(i => {
      if (!this.shiftTemplate[i]) {
        this.shiftTemplate[i] = {};
      }
    });
    const teamsData = await api.teams.getTeams();
    this.teamsList = teamsData.map(item => ({ value: item.id, text: item.name }));
    this.loaded = true;
  }
};
</script>

<style scoped lang="scss">
.always-full {
  height: calc(100vh - 120px);
  overflow-x: hidden;
}
.height100 {
  height: 100%;
}
.inputs-block {
  margin-bottom: 50px;
}
.day {
  color: #5f5f5f !important;
  font-size: 1rem !important;
  font-weight: 400;
  text-transform: uppercase;
  margin-top: 20px;
  margin-bottom: 10px;
}
.template .form-group {
  margin-bottom: 10px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
